/**
 * PublicRoute
 *
 * If a user is authenticated and attempts to access the component, they will be
 * redirected to their portfolio
 */

import { observer } from 'mobx-react'
import React, { useContext } from 'react'
import { Helmet } from 'react-helmet'
import { Navigate } from 'react-router-dom'

import { UserStoreContext } from '@/stores/UserStore'
import { CookieHubConfig } from '@/utils/cookiehubConfig'

const PublicRoute = observer(({ component: Component }) => {
  // Context
  const { accessToken } = useContext(UserStoreContext)

  return accessToken ? (
    <Navigate
      to={{
        pathname: '/dashboard',
      }}
    />
  ) : (
    <>
      <Helmet script={[...CookieHubConfig()]} />
      <Component />
    </>
  )
})

export default PublicRoute
